<div class="content-wrapper">
  <app-content-create
    [documentDataDispatcher]="documentDataDispatcher"
    [documentDataStore]="documentDataStore"
    [documentDataBuilder]="documentDataBuilder"
    [featureToggles]="featureToggles"
    [documentShipping]="documentShipping$ | async"
    [documentItems]="documentItems$ | async"
    [documentAdditionalFields]="documentAdditionalFields$ | async"
    [documentBilling]="documentBilling$ | async"
    [documentType]="documentType$ | async"
    [documentNotes]="documentNotes$ | async"
    [documentCalculationResult]="documentCalculationResult$ | async"
    [documentPaymentDetails]="documentPaymentDetails$ | async"
    [documentSettings]="documentSettings$ | async"
    [companySettings]="companySettings$ | async"
    [documentTaxes]="documentTaxes$ | async"
    [documentWithholdingTax]="documentWithholdingTax$ | async"
    [accountSettings]="accountSettings$ | async"
    [attachments]="attachments$ | async"
    [enableShipping]="enableShipping"
    [enablePaymentDetails]="enablePaymentDetails"
    [enableDiscount]="enableDiscount"
    [activeItemReferenceId]="activeItemReferenceId$ | async"
    [trackingScreenName]="trackingScreenName"
    [trackingObject]="documentTrackingObject$ | async"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
    (onUpdateContentCreate)="updateDocumentContent($event)"
    (onUpdateParentProperties)="updateDocument($event)"
    (onGrowthCta)="setInTmpCache()"
    (onActiveItemEditMode)="activeItemEditMode($event)"
  >
  </app-content-create>
</div>

<div class="aside-wrapper">
  <ng-container *ngIf="documentId$ | async; else placeholder">
    <app-aside-create
      [documentNumber]="documentNumber$ | async"
      [documentDateTerms]="documentDateTerms$ | async"
      [documentShipping]="documentShipping$ | async"
      [documentDiscount]="documentDiscount$ | async"
      [documentCalculationResult]="documentCalculationResult$ | async"
      [documentState]="documentState$ | async"
      [documentTaxes]="documentTaxes$ | async"
      [documentWithholdingTax]="documentWithholdingTax$ | async"
      [documentDueDate]="documentDueDate$ | async"
      [documentSettings]="documentSettings$ | async"
      [documentType]="documentType$ | async"
      [documentSchedule]="documentSchedule$ | async"
      [document]="document$ | async"
      [showDueDate]="showDueDate"
      [showTotal]="showTotal"
      [showPaid]="showPaid"
      [useOutstandingBalance]="useOutstandingBalance"
      [enableDiscount]="enableDiscount"
      [enableShipping]="enableShipping"
      [trackingObject]="documentTrackingObject$ | async"
      [trackingScreenName]="trackingScreenName"
      [featureToggles]="featureToggles"
      [paymentsSettings]="paymentsSettings$ | async"
      [account]="account"
      [deposit]="deposit$ | async"
      [addDepositForFuture]="addDepositForFuture$ | async"
      [enableDeposits]="enableDeposits"
      [depositRequestFeatureName]="depositRequestFeatureName"
      (onUpdateAsideCreate)="updateDocument($event)"
      (onUpdateSettingsContent)="updateSettingsContent($event)"
      (onNavigateToConvertedDoc)="navigateToConvertedDoc()"
      (onEditTaxRates)="updateDocumentTaxRates($event)"
    >
    </app-aside-create>
  </ng-container>

  <ng-template #placeholder>
    <app-placeholder-aside></app-placeholder-aside>
  </ng-template>
</div>
